import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/permissions.constants';
import { getAll, getOne, save, softDelete } from 'services/permissions.services';

export function* permissionsDelete(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.PERMISSIONS_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.PERMISSIONS_ON_DELETE_FAILED, error });
  }
}

export function* permissionsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({ type: constants.PERMISSIONS_ON_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PERMISSIONS_ON_GET_ALL_FAILED, error });
  }
}

export function* permissionsGetOne(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.PERMISSIONS_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.PERMISSIONS_ON_GET_ONE_FAILED, error });
  }
}

export function* permissionsSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.PERMISSIONS_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PERMISSIONS_ON_SAVE_FAILED, error });
  }
}

export function* permissionsRefresh(): Generator {
  const table: any = yield select((state) => state.permissions.table);
  yield put({ type: constants.PERMISSIONS_ON_GET_ALL_REQUESTED, ...table });
}

export function* watchPermissions(): Generator {
  yield all([
    takeLatest(constants.PERMISSIONS_ON_DELETE_REQUESTED, permissionsDelete),
    takeLatest(constants.PERMISSIONS_ON_GET_ALL_REQUESTED, permissionsGetAll),
    takeLatest(constants.PERMISSIONS_ON_GET_ONE_REQUESTED, permissionsGetOne),
    takeLatest(constants.PERMISSIONS_ON_SAVE_REQUESTED, permissionsSave),
    takeLatest(
      [constants.PERMISSIONS_ON_DELETE_SUCCEEDED, constants.PERMISSIONS_ON_SAVE_SUCCEEDED],
      permissionsRefresh,
    ),
  ]);
}
